import { defineMessages } from 'react-intl';

export default defineMessages({
  allRequests: {
    id: 'amc_details.suivi_dossier.all',
  },
  createdRequests: {
    id: 'amc_details.suivi_dossier.created_requests',
  },
  validatedRequests: {
    id: 'amc_details.suivi_dossier.validated_requests',
  },
  rejectedRequests: {
    id: 'amc_details.suivi_dossier.rejected_requests',
  },
});
